

























































import Vue from 'vue'
import Component from 'vue-class-component'
import LoginPanel from '@/components/entrance/LoginPanel.vue'
import CreateCompanyAccountPanel from '@/components/entrance/CreateCompanyAccountPanel.vue'
import appManager from '@/services/AppManager'
import { RoutePaths } from '@/router'

@Component({
    components: {
        CreateCompanyAccountPanel,
        LoginPanel
    }
})
export default class EntranceView extends Vue {
    getWindowIndex(): number {
        return (this.isSubPanelCreate() || this.isSubPanelLogin()) ? 1 : 0
    }

    isSubPanelCreate(): boolean {
        return !!this.$route.query['portal_create']
    }

    isSubPanelLogin(): boolean {
        return !!this.$route.query['portal_login']
    }

    onHomePressed() {
        this.$router.push(RoutePaths.LANDING_HOME)
    }

    onCreateCompanyAccountPressed() {
        this.$router.push({
            path: this.$route.path,
            query: {
              portal_create: '1'
            }
        })
    }

    onLogInPressed() {
        this.$router.push({
            path: this.$route.path,
            query: {
                portal_login: '1'
            }
        })
    }

    onBackPressed() {
        this.$router.back()
    }

    getAppVersion(): string {
        return appManager.appVersion
    }
}
